export const getIsClassificationAnnotationsPagesTimelineOpen = (state) =>
  state.classificationAnnotationsPagesTimeline.isTimelineOpen
export const getPagesList = (state) => state.classificationAnnotationsPagesTimeline.pagesList
export const getIsProcessing = (state) => state.classificationAnnotationsPagesTimeline.isProcessing
export const getIsAddClassificationAnnotationsDialogOpen = (state) =>
  state.classificationAnnotationsPagesTimeline.isAddClassificationAnnotationsDialogOpen
